/**
 * Procedure Categories and Procedures for MD / Diploma in Radio-diagnosis students
 * Extracted with strict evidence from official NMC PDF (Page 3-4: "Skills in performing a procedure")
 */
export const RADIODIAGNOSIS_PROCEDURES = {
  "Fluoroscopic & Contrast Imaging Procedures": [
    "Barium Studies (Swallow, Upper GI, Follow-Through, Enema)",
    "Fistulography, Sialography, and Cologram / Ileostogram",
    "Excretory Urography (IVU / IVP)",
    "Micturating Cystourethrogram (MCU) & Retrograde Urethrogram (RUG)",
    "Nephrostogram & Genitogram",
  ],
  "Ultrasonography & Sectional Imaging Procedures": [
    "Whole Body Ultrasonography & Doppler Studies",
    "Neonatal Transfontanelle Ultrasound Studies",
    "Triple Phase CT Scan Performance & Image Reconstruction",
    "CT Enterography & CT Angiography Performance",
    "Whole Body MRI Scan Performance & Planning",
    "Radiography of Common and Uncommon Views (Positioning, Exposure & Development)",
  ],
  "Interventional Radiology & Vascular Procedures": [
    "Ultrasound and Fluoroscopy Guided Abscess Drainage",
    "Drainage Catheter Placement",
    "Percutaneous Nephrostomy (PCN)",
    "Percutaneous Biliary Drainage",
    "Transfemoral Puncture and Arterial Catheter Insertion (DSA)",
  ],
};

export const RADIODIAGNOSIS_CATEGORIES = Object.keys(RADIODIAGNOSIS_PROCEDURES);

export const isDiplomaInRadioDiagnosisDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return (
    (d.includes("dmrd") ||
    d.includes("radio-diagnosis") ||
    d.includes("radiodiagnosis") ||
    d.includes("radiology")) &&
    !d.includes("neuro")
  );
};

